import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import TranslationInput from '../../component/dccore-form/translationInput.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'

if ($('#mealtype_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#mealtype_form',
    components: {
      RingLoader,
      DcForm,
      multimedia,
      TextInput,
      TranslationInput,
      Singleselect,
    },
    mixins: [mixins],
    data: {
      loading: 0,
      entityId: null,
      form: {
        rows: [
          {
            type: 'header',
            content: {
              title: Translator.trans('form.general_information')
            }
          },
          {
            type: 'row',
            cols: [
              {
                type: 'text',
                content: {
                  name: 'name',
                  title: Translator.trans('meal_type.entity.name'),
                }
              },
              {
                type: 'text',
                content: {
                  name: 'position',
                  title: Translator.trans('meal_type.entity.position'),
                }
              }
            ],
          },
        ],
        entity: {},
        options: {
          errors: {},
          selectTypes: [],
        },
      },
      multimedia: []
    },
    mounted() {
      this.getSelectTypes()
      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getEntity()
      }
    },
    methods: {
      createMealType(redirect) {
        //this.buttonSave.button('loading');
        let url = Routing.generate('api_post_meal_type')

        let data = {
          data: this.form.entity,
          multimedia: this.multimedia
        }
        this.loading++
        this.$http.post(url, data).then(() => {
          this.errors = {}
          if (redirect) {
            $(location).attr('href', Routing.generate('meal_type_grid'))
          } else {
            toastr.success(Translator.trans('meal_type.create.created'))
          }
          this.loading--
        }, response => {
          this.handleAjaxError(response, this.form.options)
          this.loading--
        })

      },
      updateMealType(redirect) {
        //this.buttonSave.button('loading');
        let url = Routing.generate('api_patch_meal_type', { id: this.entityId })

        let data = {
          data: this.form.entity,
          multimedia: this.multimedia
        }
        this.loading++
        this.$http.patch(url, data).then(() => {
          this.errors = {}
          if (redirect) {
            $(location).attr('href', Routing.generate('meal_type_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('meal_type.update.updated'))
          }
          this.loading--
        }, response => {
          this.handleAjaxError(response, this.form.options)
          this.loading--
        })

      },
      getEntity() {
        let url = Routing.generate('api_get_meal_type', { id: this.entityId,
          context: 'edit' })
        this.loading++
        this.$http.get(url).then(response => {
          delete response.data.id
          this.form.entity = response.data
          if (this.form.entity.multimedia) {
            this.multimedia = Object.assign({}, this.form.entity.multimedia.collection)
          }
          delete this.form.entity.multimedia
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })

      },
      getSelectTypes() {
        let url = Routing.generate('api_get_tags', {
          'type': 'types_select',
          context: 'dropdown',
        })
        this.loading++
        Vue.http.get(url).then(response => {
          this.form.options.selectTypes = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      }
    }
  })
}
